
import { defineComponent } from "vue";
import FormGroupBlock from "Components/common/controls/FormGroupBlock.vue";
import { EventInput } from "Models";

export default defineComponent({
  emits: ["update:modelValue"],
  components: { FormGroupBlock },
  props: {
    label: String,
    modelValue: {},
    modelModifiers: {
      default: () => ({}),
    },
    type: {
      type: String,
      default: "text",
    },
    isEditor: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    mask: {},
    placeholder: String,
    inputClass: Object,
    borderClass: Object,
  },
  methods: {
    updateInput($event: EventInput) {
      this.$emit("update:modelValue", $event.target.value);
    },
  },
});
